import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticHeader from "../static/common_components/staticHeader";
import Carousel from "../static/common_components/carousel";
import $ from "jquery";
import { getCurrentAwardDetails_action, getActiveJuryDetails_action } from "../../actions/static_action/currentAwardDetails_action";
import { BASE_URL, toastError, toastSuccess } from "../../utils/constants";
import Loader from "../../utils/Loader";
import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel";
import moment from "moment";
import { Modal } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
    getCmsContent_action, insertUpdateCmsContent_action,
    insertUpdateCmsFooter_action, publishCmsContent_action,
    publishCmsFooter_action, insertUpdateCmsContentSection_action,
    updateCmsContentStatus_action, insertUpdateCMSStaticUploads_action,
    deleteCmsStaticFiles_action, publishCmsBanner_action, insertUpdateCmsBanner_action
} from "../../actions/cms_action/cmsAction";
import Resizer from "react-image-file-resizer";

const joditConfig = {
    readonly: false,
    height: 500,
    placeholder: "",
    disableBeautify: true,
    useAceEditor: false,
    uploader: { insertImageAsBase64URI: true },
    showAbout: false,
    showPoweredBy: false,
    buttons: [
        'bold', 'strikethrough', 'underline', 'italic', '|',
        'ul', 'ol', '|',
        'outdent', 'indent', '|', 'image', 'video', 'table', 'link', '|',
        'fontsize', 'brush', 'paragraph', '|',
        'align', 'fullsize', "undo", "redo", "search", '|',
        'source', // <-- This is the code editor toggle
        {
            name: "more",
            iconURL: "https://cdn-icons-png.flaticon.com/512/130/130884.png",
            tooltip: "More Options",
            list: ["superscript", "subscript", "copyformat", "print", "hr", 'copyformat'],
        },
    ],
    toolbarAdaptive: false,
    toolbarSticky: false,
    toolbarButtonSize: "middle",
    buttonsXS: [
        'bold', 'image', '|', 'brush', 'paragraph', '|',
        'align', '|', 'undo', 'redo', '|', 'eraser', 'dots', 'more', 'source' // Added here too
    ],
    buttonsSM: ["bold", "italic", "underline", "link", "more", "source"], // Added here too
    style: {
        toolbar: {
            display: "flex",
            justifyContent: "space-between"
        },
    },
    dropdown: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "10px",
        padding: "10px",
    },
    defaultStyle: 'font-family: sans serif; font-size: 14px;',
    placeholder: "",
};

let sectionCounter = 1;
class CmsHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            awardCarouselList: [],
            isLoading: false,
            awardEventYear: "",
            awardEventName: "",
            venueDate: "",
            venueName: "",
            awardEventDecription: "",
            award_address: "",
            speakers: [],
            JuryName: '',
            JuryPDF: '',
            isOpen: false,
            isStaticUploadOpen: false,
            applicationStartDate: '',
            applicationEndDate: '',
            currentDate: '',
            isOpen2: false,
            LaunchDate: '',
            //cms
            cmsSectionData: [],
            cmsMenuData: [],
            cmsFooterData: [], MenuUrl: '',
            MenuID: '', ContentID: '', SectionName: '',
            SeqNo: '', isFixed: '', isEdit: '', SectionContent: '',
            isactive: '', isPublish: '',
            cmsUploadData: [], downloadUrl: '',
            cmsSubheaderData: [], cmsBannerData: [], bannerFileErr: ''
        };
        this.slidesToShow = 5;
        this.slideInterval = 3000;
        this.slider3Ref = React.createRef()
        this.clearFileInput = this.clearFileInput.bind(this);
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }

        setTimeout(() => {
            {
                (sessionStorage.getItem("role_id") != 1 && sessionStorage.getItem("role_id") != 3 && sessionStorage.getItem("role_id") != 5) ? (
                    this.props.navigate("/login")
                ) : <></>
            }
        }, 10);
        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });
        if (this.props.location.pathname == '/cms/manage') {
            this.setState({ MenuUrl: 'home', MenuID: 1, cmsMenuData: [] }, () => {
                this.getCmsContent(1, 'home');
                this.getCurrentAwardDetails();
            });
            return
        }

        const path = this.props.location.pathname; // e.g., '/cms/manage/current-awards&4'
        const cmsPrefix = '/cms/manage';

        if (path.startsWith(cmsPrefix)) {
            const subPath = path.slice(cmsPrefix.length); // gets 'current-awards&4'
            console.log(path, subPath, 'cmspath')

            const parts = subPath.split('&');

            if (parts.length === 2) {
                const MenuUrlProps = parts[0]; // 'current-awards'
                const MenuIDProps = parts[1];  // '4'

                console.log("Menu URL mount:", MenuUrlProps);
                console.log("Menu ID mount:", MenuIDProps);
                // if (MenuID != MenuIDProps) {
                this.setState({ MenuUrl: MenuUrlProps, MenuID: MenuIDProps, cmsMenuData: [] }, () => {
                    this.getCmsContent(MenuIDProps ? MenuIDProps : 1, MenuUrlProps ? MenuUrlProps : 'home');
                });
                // }
            }
        }

        // this.setState({ MenuID: this.state.MenuID ? this.state.MenuID : 1, MenuUrl: this.state.MenuUrl ? this.state.MenuUrl : 'home' }, () => {
        //     this.getCurrentAwardDetails();
        //     this.getCmsContent(this.state.MenuID, this.state.MenuUrl)
        // })
        this.startAutoSlide();
        this.jQuery();
        this.loadscript();

    }
    componentDidUpdate(prevProps) {

        if (this.props.location.pathname !== prevProps.location.pathname) {
            const path = this.props.location.pathname; // e.g., '/cms/manage/current-awards&4'
            const cmsPrefix = '/cms/manage';

            if (path.includes('current-awards&4')) {
                window.open('#/category', '_blank');
            } else {
                if (path.startsWith(cmsPrefix)) {
                    const subPath = path.slice(cmsPrefix.length);
                    const parts = subPath.split('&');

                    if (parts.length === 2) {
                        const MenuUrlProps = parts[0]; // 'current-awards'
                        const MenuIDProps = parts[1];  // '4'

                        this.setState({ MenuUrl: MenuUrlProps, MenuID: MenuIDProps, cmsMenuData: [] }, () => {
                            this.getCmsContent(MenuIDProps, MenuUrlProps);
                        });
                        // }
                    }
                }
            }
        }
    }

    jQuery(retry = 0) {
        const that = this; // 👈 Capture the correct 'this' context

        (function ($) {
            const $testimonials = $(".testimonial-slide");

            if ($testimonials.length === 0 && retry < 10) {
                setTimeout(() => that.jQuery(retry + 1), 200); // 👈 Use 'that' instead of 'this'
                return;
            }

            // LIGHTGALLERY init
            const galleryEl = document.getElementById("selector1");
            if (galleryEl) {
                lightGallery(galleryEl, {
                    selector: ".item",
                    plugins: [lgThumbnail],
                    allowMediaOverlap: true,
                    toggleThumb: true,
                });
            }

            // BACK TO TOP
            $(document).on("click", "#back-to-top, .back-to-top", () => {
                $("html, body").animate({ scrollTop: 0 }, 500);
                return false;
            });

            $(window).on("scroll", () => {
                if ($(window).scrollTop() > 500) {
                    $("#back-to-top").fadeIn(200);
                } else {
                    $("#back-to-top").fadeOut(200);
                }
            });

            // SLICK
            if ($testimonials.length > 0) {
                $testimonials.slick({
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    arrows: false,
                    dots: false,
                    responsive: [
                        { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                    ],
                });
            }
        })($);
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    componentWillUnmount() {
        clearInterval(this.autoSlideInterval);
    }

    startAutoSlide = () => {
        this.autoSlideInterval = setInterval(() => {
            this.moveSlide(1);
        }, this.slideInterval);
    };

    moveSlide = (step) => {
        const { currentIndex, awardCarouselList } = this.state;
        const totalSlides = awardCarouselList.length;
        const newIndex = (currentIndex + step + totalSlides) % totalSlides;
        this.setState({ currentIndex: newIndex });
    };

    getCurrentAwardDetails = async () => {
        try {
            this.setState({ isLoading: true });
            const { award_event_profile_id } = this.state;

            const data = await this.props.getCurrentAwardDetails_action(
                award_event_profile_id !== "" ? award_event_profile_id : null
            );
            if (data.error !== 1) {
                if (data.applicationDate && data.applicationDate.length > 0) {
                    const now = moment().format('DD-MM-YYYY');
                    const startDate = moment(data.applicationDate[0]["application_start_date"]).format('DD-MM-YYYY');
                    const endDate = moment(data.applicationDate[0]["application_end_date"]).format('DD-MM-YYYY');

                    this.setState({
                        applicationStartDate: startDate,
                        applicationEndDate: endDate,
                        currentDate: now,
                    });
                }

                if (data.data && data.data.length > 0) {
                    const formattedDate = moment(data.data[0]["award_event_to_date"]).format("DD MMM YYYY");
                    const year = moment(data.data[0]["award_event_to_date"]).format("YYYY");

                    this.setState({
                        isLoading: false,
                        awardCarouselList: data.data,
                        awardEventYear: year,
                        awardEventName: data.data[0]["award_event_name"],
                        award_address: data.data[0]["award_address"],
                        awardEventDecription: data.data[0]["award_event_description"],
                        venueDate: formattedDate,
                        venueName: "",
                    });

                    if (data.data2 && data.data2.length > 0) {
                        sessionStorage.setItem("award_event_id", data.data2[0]["award_event_id"]);
                        setTimeout(() => {
                            this.getActiveJuryDetails();
                        }, 100);
                    }
                } else {
                    this.setState({ isLoading: false });
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    getActiveJuryDetails = async () => {
        try {
            this.setState({ isLoading: true });

            const award_event_id = sessionStorage.getItem("award_event_id");
            const data = await this.props.getActiveJuryDetails_action(
                award_event_id !== "" ? award_event_id : null
            );

            if (data.error !== 1) {
                if (data.data && data.data.length > 0) {
                    const filterArray = data.data.map((item) => ({
                        name: item.name,
                        role: item.designation,
                        company_name: item.company_name,
                        imgSrc: item.profile_image
                            ? BASE_URL.split('/api')[0] + item.profile_image
                            : null,
                        juryDetailsPdf: item.profile_filepath
                            ? BASE_URL.split('/api')[0] + item.profile_filepath
                            : null,
                    }));

                    this.setState({
                        isLoading: false,
                        speakers: filterArray,
                    });
                } else {
                    this.setState({ isLoading: false });
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }


    onAwardApply(award_event_profile_id) {
        if (award_event_profile_id != null) {
            this.props.navigate("/category", {
                state: {
                    award_event_profile_id: award_event_profile_id,
                    isAllCategory: false,
                },
            });
        } else {
            this.props.navigate("/category", { state: { isAllCategory: true } });
        }
    }
    //dynamic cmsSectionData
    async getCmsContent(MenuID, MenuURL) {
        const path = this.props.location.pathname;
        const cmsPrefix = '/cms/manage';
        let MenuUrlProps
        let MenuIDProps
        if (path.startsWith(cmsPrefix)) {
            const subPath = path.slice(cmsPrefix.length);
            console.log(path, subPath, 'cmspath')

            const parts = subPath.split('&');

            if (parts.length === 2) {
                MenuUrlProps = parts[0];
                MenuIDProps = parts[1];
            }
        }
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(MenuID ? MenuID : MenuIDProps ? MenuIDProps : 1, MenuURL ? MenuURL : MenuUrlProps ? MenuUrlProps : 'home');

            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsSectionData: data?.data[0] !== "" ? data?.data[0] : [],
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsFooterData: data?.data[2][0] !== "" ? data?.data[2][0] : [],
                    cmsUploadData: data?.data[3] !== "" ? data?.data[3] : [],
                    cmsSubheaderData: data?.data[4] !== "" ? data?.data[4] : [],
                    cmsBannerData: data?.data[5][0] !== "" ? data?.data[5][0] : [],
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
                if (data.msg == 'Page not found.') {
                    if (this.props.location.pathname.includes('cms/manage')) {
                        window.location.reload()
                        this.props.navigate('/cms/manage')
                    } else {
                        window.location.reload()
                        this.props.navigate('/')
                    }
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    InsertUpdateCmsContentSection = async (ContentID, MenuID, SeqNo, isFixed, isEdit, SectionContent, isPublish, isactive) => {
        try {
            this.setState({ isLoading: true });
            if (SectionContent == '' || SectionContent == '<p><br/></p>') {
                toastError('Kindly Enter Content')
            } else {
                const data = await this.props.insertUpdateCmsContentSection_action(ContentID, MenuID, SeqNo, isFixed, isEdit, SectionContent, isPublish, isactive);
                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    if (data.data !== "") {
                        toastSuccess('Content Added Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }

        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async InsertUpdateCmsContent() {
        try {
            const { cmsSectionData } = this.state;
            this.setState({ isLoading: true });
            const hasInvalidContent = cmsSectionData.some(section => {
                const content = section.SectionContent?.trim();
                return !content || content === '<p><br/></p>';
            });

            if (hasInvalidContent) {
                toastError('Kindly Enter Content in all sections');
                this.setState({ isLoading: false });
                return;
            } else {
                const data = await this.props.insertUpdateCmsContent_action(cmsSectionData);

                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    if (data.data !== "") {
                        toastSuccess('Contents Added Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async insertUpdateFooter() {
        try {
            const { cmsFooterData } = this.state;
            this.setState({ isLoading: true });
            if (cmsFooterData.FooterContent == '' || cmsFooterData.FooterContent == '<p><br/></p>') {
                toastError('Kindly Enter Footer Section')
            } else {
                const data = await this.props.insertUpdateCmsFooter_action(cmsFooterData);

                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    if (data.data !== "") {
                        toastSuccess('Footer Saved Successfully')
                        this.getCmsContent()
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async updateCmsContentStatus(ContentID, isactive) {
        try {
            const { MenuID } = this.state;
            this.setState({ isLoading: true });

            const data = await this.props.updateCmsContentStatus_action(MenuID, ContentID, isactive);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Content ${isactive == 1 ? 'Activated' : 'In-Activated'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async deleteCmsStaticFiles(FileID) {
        try {
            const { MenuID } = this.state;
            this.setState({ isLoading: true });

            const data = await this.props.deleteCmsStaticFiles_action(MenuID, FileID);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`File Deleted Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async PublishCmsContent(ContentID, isPublish) {
        try {
            const { MenuID } = this.state;
            this.setState({ isLoading: true });

            const data = await this.props.publishCmsContent_action(MenuID, ContentID, isPublish);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Content ${isPublish == 1 ? 'Published' : 'Unpublished'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    async PublishCmsFooter(isPublish) {
        const { cmsFooterData } = this.state
        try {
            this.setState({ isLoading: true });

            const data = await this.props.publishCmsFooter_action(cmsFooterData.FooterID, isPublish);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Footer ${isPublish == 1 ? 'Published' : 'Unpublished'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async PublishCmsBanner(BannerID,isPublish) {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.publishCmsBanner_action(BannerID,isPublish);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Banner ${isPublish == 1 ? 'Published' : 'Unpublished'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    UploadBannerFile = async () => {
        const { cmsBannerData } = this.state
        console.log(cmsBannerData, 'cmsBannerData')
        if (cmsBannerData.length == 0 || cmsBannerData == []) {
            toastError('Kindly Upload File')
            return
        }
        try {
            this.setState({ isLoading: true });
            if (cmsBannerData.length == 0) {
                toastError('Kindly Upload File')
                this.setState({ bannerFileErr: 'Kindly Upload File' })
            } else {
                const data = await this.props.insertUpdateCmsBanner_action(cmsBannerData);
                if (data.error !== 1) {
                    this.setState({ isLoading: false, isStaticUploadOpenBanner: false, bannerFileErr: '' });
                    if (data.data !== "") {
                        toastSuccess('Banner Uploaded Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }

        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    UploadStaticFiles = async () => {
        const { cmsUploadData } = this.state
        if (cmsUploadData.length == 0 || cmsUploadData == []) {
            toastError('Kindly Upload Files')
            return
        }
        try {
            this.setState({ isLoading: true });
            if (cmsUploadData.length == 0) {
                toastError('Kindly Upload Files')
            } else {
                const data = await this.props.insertUpdateCMSStaticUploads_action(cmsUploadData);
                if (data.error !== 1) {
                    this.setState({ isLoading: false, isStaticUploadOpen: false });
                    if (data.data !== "") {
                        toastSuccess('Files Uploaded Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }

        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    toggleUploadFileOpen = () => {
        this.setState({ isStaticUploadOpen: true })
    }
    toggleUploadFileOpenBanner = () => {
        this.setState({ isStaticUploadOpenBanner: true })
    }
    handleAddSection = () => {
        const { ContentID, MenuID } = this.state;
        const sectionName = `section-${sectionCounter++}`;
        const newSection = {
            SectionName: sectionName,
            ContentID: ContentID ? ContentID : 0,
            MenuID: MenuID ? MenuID : 1,
            SeqNo: this.state.cmsSectionData.length + 1,
            isFixed: false,
            isEdit: true,
            SectionContent: '',
            isactive: 1,
            isPublish: 0
        };

        this.setState(
            prevState => ({
                cmsSectionData: [...prevState.cmsSectionData, newSection]
            }),
            () => {
                // Scroll to the new section after it's rendered
                setTimeout(() => {
                    const el = document.getElementById(sectionName);
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 100); // Give React time to render
            }
        );
    };

    handleEditorChange = (content, index) => {
        const cmsSectionData = [...this.state.cmsSectionData];
        cmsSectionData[index].SectionContent = content;
        this.setState({ cmsSectionData });
    };
    handleEditorChangeFooter = (content) => {
        const cmsFooterData = { ...this.state.cmsFooterData }; // shallow copy of the object
        cmsFooterData.FooterContent = content;
        this.setState({ cmsFooterData });
    };

    onDragEnd = (result) => {
        const { destination, source } = result;
        if (!destination) return;

        const sourceSection = this.state.cmsSectionData[source.index];
        const destSection = this.state.cmsSectionData[destination.index];

        // Don't allow drag if either isFixed
        if (sourceSection.isFixed || destSection.isFixed) return;

        const items = Array.from(this.state.cmsSectionData);
        const [reorderedItem] = items.splice(source.index, 1);
        items.splice(destination.index, 0, reorderedItem);

        // Update sequence numbers
        items.forEach((item, index) => {
            item.SeqNo = index + 1;
        });

        this.setState({ cmsSectionData: items });
    };
    handleRemoveSection = (indexToRemove, ContentID) => {
        let updatedcmsSectionData;

        if (ContentID !== 0) {
            updatedcmsSectionData = this.state.cmsSectionData.map((section, index) => {
                if (index === indexToRemove) {
                    return {
                        ...section,
                        isactive: 0
                    };
                }
                return section;
            });
        } else {
            updatedcmsSectionData = this.state.cmsSectionData.filter((_, index) => index !== indexToRemove);
        }

        const reSequenced = updatedcmsSectionData.map((section, idx) => ({
            ...section,
            SeqNo: idx + 1
        }));

        this.setState({ cmsSectionData: reSequenced });
    };
    toggleSectionStatus = (index, ContentID, isactive) => {
        const updatedcmsSectionData = this.state.cmsSectionData.map((section, idx) => {
            if (idx === index) {
                return {
                    ...section,
                    isactive: section.isactive ? 0 : 1,
                };
            }
            return section;
        });

        this.setState({ cmsSectionData: updatedcmsSectionData }, () => {
            this.updateCmsContentStatus(ContentID, !isactive)
        });
    };
    handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        if (files.length > 10) {
            alert("You can upload a maximum of 10 files.");
            return;
        }

        const oversized = files.find(file => file.size > 20 * 1024 * 1024); // 20MB
        if (oversized) {
            alert(`File "${oversized.name}" exceeds the 20MB limit.`);
            return;
        }

        const newUploadData = files.map(file => {
            const reader = new FileReader();
            const fileExt = file.name.split('.').pop();

            return new Promise((resolve) => {
                reader.onload = (e) => {
                    resolve({
                        FileID: 0,
                        MenuID: this.state.MenuID,
                        FilePath: "",
                        FileName: file.name,
                        FileSize: file.size, // Add file size to track uniqueness
                        formFile: e.target.result.split(',')[1],
                        formFileType: fileExt,
                        isPublish: 1,
                        isActive: 1
                    });
                };
                reader.readAsDataURL(file);
            });
        });

        Promise.all(newUploadData).then(uploadData => {
            this.setState(prevState => {
                const existing = prevState.cmsUploadData || [];

                // Remove duplicates by FileName + FileSize
                const filteredNew = uploadData.filter(newFile =>
                    !existing.some(existingFile =>
                        existingFile.FileName === newFile.FileName &&
                        existingFile.FileSize === newFile.FileSize
                    )
                );

                return {
                    cmsUploadData: [...existing, ...filteredNew]
                };
            });
        });
    };

    removeFile = (index, FileID) => {
        this.setState(prevState => {
            const updatedFiles = [...prevState.cmsUploadData];
            const file = updatedFiles[index];
            if (file.FileID && file.FileID !== 0) {
                updatedFiles[index].isActive = 0;
                this.deleteCmsStaticFiles(FileID);
            } else {
                updatedFiles.splice(index, 1); // Remove completely
            }
            return { cmsUploadData: updatedFiles };
        });
    };
    clearFileInput() {
        this.setState({ cmsBannerData: [] })
    }
    handleBannerChange = async (event) => {
        const file = event.target.files[0];

        if (!file) return;

        if (file.size > 10 * 1024 * 1024) {
            alert(`File "${file.name}" exceeds the 10MB limit.`);
            return;
        }

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            toastError("Only .jpeg, .png, .jpg files are allowed");
            event.target.value = null;
            this.clearFileInput();
            return;
        }

        const image = await this.resizeFile(file);
        const fileExt = file.name.split('.').pop();

        const reader = new FileReader();
        reader.onload = (e) => {
            const uploadData = {
                BannerID: null,
                BannerFilepath: "",
                FilePreview: image,
                FileName: file.name,
                formfile: image.split(',')[1],
                formFileType: fileExt,
                isPublish: 1,
                isActive: 1
            };

            this.setState(prevState => ({
                cmsBannerData: Array.isArray(prevState.cmsBannerData) ? [...prevState.cmsBannerData, uploadData] : [uploadData]
            }));
        };

        reader.readAsDataURL(file);
    };
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 500, 600, "JPEG", 80, 0,
                (uri) => { resolve(uri); },
                "base64", 300, 300);
        });
    render() {
        const {
            cmsSectionData, cmsMenuData,
            cmsFooterData,
            MenuID, ContentID, SectionName,
            SeqNo, isFixed, isEdit, SectionContent,
            isactive, isPublish,
            awardCarouselList,
            isLoading,
            awardEventName,
            speakers,
            JuryName,
            JuryPDF,
            currentDate,
            applicationStartDate,
            applicationEndDate, isStaticUploadOpen, MenuUrl,
            cmsUploadData, downloadUrl, isStaticUploadOpenBanner, cmsBannerData, bannerFileErr
        } = this.state;
        function parseDate(dateString) {
            const [day, month, year] = dateString.split("-").map(Number);
            return new Date(year, month - 1, day); // Month is 0-indexed
        }
        return (
            <>
                <StaticHeader headerNavs={cmsMenuData} />
                {isLoading ? <Loader></Loader> : null}
                <>
                    <div className="website">
                        {MenuID == 1 && <>
                            <section className="banner position-relative pb-0">
                                <div className="overlay"></div>
                                <div className="container">
                                    <div className="inner-banner position-relative text-white ">
                                        <div className="row">
                                            <div className="col-lg-10">
                                                <div className="banner-right  ms-2 text-center text-lg-start pb-8">
                                                    <div className="banner-title pb-3">
                                                        {/* <h4 className="text-white pb-3">
                                                                   UPCOMING <span className="pink">AWARDS</span>
                                                                 </h4> */}
                                                        <h1 className="text-white">
                                                            <span className="pink">{awardEventName ? awardEventName : 'India ITME Awards'}</span>{" "}
                                                        </h1>
                                                        <h5 style={{ color: 'white' }}>Exclusively for Textile Technology & Engineering Sectors</h5>
                                                    </div>
                                                    <div className="banner-event-info pb-3">
                                                        <ul className="m-0 ps-0 d-sm-flex justify-content-center justify-content-lg-start list-unstyled">
                                                            {/* <li className="pe-2 border-end border-1 border-lightgrey">
                                                                     <i className="fa  fa-calendar-o pe-1" />{" "}
                                                                     {venueDate}
                                                                   </li>
                                                                   <li className="ps-2">
                                                                     <i className="fa  fa-map-marker pe-1" />
                                                                     {award_address}
                                                                   </li> */}
                                                            {(!applicationStartDate && !applicationEndDate) ? (
                                                                <></>
                                                                // <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                                                //     <i className="fa fa-calendar-o pe-1" /> Launching - 21 Feb, 2025
                                                                // </li>
                                                            ) : (
                                                                parseDate(applicationStartDate) > parseDate(currentDate) ? (
                                                                    <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                                                        <i className="fa fa-calendar-o pe-1" /> Launching - {applicationStartDate && moment(applicationStartDate, 'DD-MM-YYYY').format('DD MMM, YYYY')}
                                                                    </li>
                                                                ) : (
                                                                    applicationStartDate === currentDate ? (
                                                                        <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                                                            <i className="fa fa-calendar-o pe-1" /> The application process has started
                                                                        </li>
                                                                    ) : (
                                                                        (parseDate(applicationStartDate) <= parseDate(currentDate)) && (parseDate(currentDate) <= parseDate(applicationEndDate)) ? (
                                                                            <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                                                                <i className="fa fa-calendar-o pe-1" /> Last date of application submission - {applicationEndDate && moment(applicationEndDate, 'DD-MM-YYYY').format('DD MMM, YYYY')}
                                                                            </li>
                                                                        ) : (
                                                                            parseDate(currentDate) > parseDate(applicationEndDate) ? (
                                                                                <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                                                                    <i className="fa fa-calendar-o pe-1" /> The application closed on - {applicationEndDate && moment(applicationEndDate, 'DD-MM-YYYY').format('DD MMM, YYYY')}
                                                                                </li>
                                                                            ) : (
                                                                                <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                                                                    <i className="fa fa-calendar-o pe-1" /> The application will coming soon
                                                                                </li>
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )}

                                                        </ul>
                                                    </div>
                                                    {/* <div className="event-discription">
                                                                 <p className="pb-4 m-0" >
                                                                   {awardEventDecription}
                                                                 </p>
                                                               </div> */}
                                                </div>
                                            </div>

                                            <div className="col-lg-2 text-center">
                                                {/* <div className="video-box">
                                                               <a href="https://youtu.be/ag47pOihPx4" className="play-btn" target="_blank" rel="noopener noreferrer">
                                                                 <img className="rotate360" src="../static/images/heroShape2_1.png" alt="shape" />
                                                               </a>
                                                             </div> */}
                                                {/* <div class="video-box">
                                         <a href="https://youtu.be/ag47pOihPx4" class="play-btn" target="_blank" rel="noopener noreferrer">
                                           <div class="wave-container">
                                             <img class="rotate-animation" src="../static/images/heroShape2_1.png" alt="shape" />
                                           </div>
                                         </a>
                                       </div> */}

                                                <div class="video-box">
                                                    <a href="https://www.youtube.com/watch?v=WWBKrtKRCWk" class="play-btn" target="_blank" rel="noopener noreferrer">
                                                        <div class="wave-container">
                                                            <div class="wave-bg"></div>
                                                            <img class="rotate-animation" src="../static/images/heroShape2_1.png" alt="shape" />
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className="news-archive pb-0"
                                style={{ paddingTop: 60, paddingBottom: 0, position: "relative" }}>
                                <div className="container" style={{ transform: "translate(0%, -32%)" }}>
                                    <div className="news-archive-inner">
                                        <div className="speaker-title text-center p-2">
                                            <div className="row align-items-center ">
                                                <div className="col-lg-6"></div>
                                            </div>
                                        </div>
                                        <div className="row gy-5">
                                            {awardCarouselList.length > 0 ? <>
                                                <div className="col-lg-12">
                                                    {awardCarouselList.length > 0 ? <Carousel state={{ awardCarouselList: awardCarouselList, screen: 'index' }} /> : <p>Record Not Found</p>}
                                                </div>
                                            </> : <></>}
                                            {awardCarouselList.length > 0 ?
                                                <div className="speaker-button text-lg-center m-0 mt-3 text-center">
                                                    <a className="btn my-2"
                                                        onClick={() => this.onAwardApply(null, null)}
                                                    >See all Awards{" "}
                                                        <i className="fa fa-angle-double-right" />
                                                    </a>
                                                </div> : <></>}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </>}
                        {/* how to apply */}
                        <div className="mx-2" style={{ margin: 'auto', paddingTop: `${MenuID == 1 ? '10px' : '150px'}` }}>
                            <h2 className="mb-2 text-center">CMS Section Editors {" "}
                                <button className="btn  btn-sm px-3 mb-1" onClick={this.handleAddSection}>Add Section</button>
                                <button className="btn  btn-sm px-3 mb-1 mx-2" onClick={this.toggleUploadFileOpen}>Upload Files</button>
                                <button className="btn  btn-sm px-3 mb-1 mx-2" onClick={this.toggleUploadFileOpenBanner}>Upload Banner</button>
                            </h2>
                            <DragDropContext onDragEnd={this.onDragEnd}>
                                <Droppable droppableId="cmsSectionData-droppable">
                                    {(provided) => (
                                        <div {...provided.droppableProps} ref={provided.innerRef}>
                                            {cmsSectionData?.length > 0 ? cmsSectionData?.map((section, index) => (
                                                <Draggable
                                                    key={section.ContentID}
                                                    draggableId={String(section.ContentID)}
                                                    index={index}
                                                    isDragDisabled={section.isFixed}
                                                >
                                                    {(provided) => (
                                                        <div
                                                            id={section.SectionName}
                                                            className="focus-sec first-sec"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            style={{
                                                                border: '1px solid #ccc',
                                                                padding: '10px',
                                                                borderRadius: '10px',
                                                                marginBottom: '15px',
                                                                backgroundColor: '#f9f9f9',
                                                                ...provided.draggableProps.style,
                                                            }}
                                                        >
                                                            {/* DRAG HANDLE ONLY APPLIED HERE */}
                                                            <div
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    marginBottom: '5px',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    cursor: 'grab',
                                                                }}
                                                            >
                                                                <strong>Section #{section.SeqNo}</strong>
                                                                <div>
                                                                    {section.isFixed && (
                                                                        <span style={{ color: 'red', marginRight: '10px' }}>
                                                                            (Fixed)
                                                                        </span>
                                                                    )}
                                                                    <button
                                                                        className="btn btn-sm px-3 p-1 rounded-1 edit-submit-btn"
                                                                        onClick={() =>
                                                                            this.InsertUpdateCmsContentSection(
                                                                                section.ContentID,
                                                                                section.MenuID,
                                                                                section.SeqNo,
                                                                                section.isFixed,
                                                                                section.isEdit,
                                                                                section.SectionContent,
                                                                                section.isPublish,
                                                                                section.isactive
                                                                            )
                                                                        }
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm px-3 p-1 rounded-1 ml-1 add-sec-btn"
                                                                        onClick={this.handleAddSection}
                                                                    >
                                                                        Add Section
                                                                    </button>
                                                                    {section.isactive && (
                                                                        <>
                                                                            {section.isPublish ? (
                                                                                <button
                                                                                    className="btn btn-sm p-1 px-3 mx-1 rounded-1 add-unp-btn"
                                                                                    onClick={() =>
                                                                                        this.PublishCmsContent(section.ContentID, 0)
                                                                                    }
                                                                                >
                                                                                    Unpublish
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    className="btn btn-sm p-1 px-3 mx-1 rounded-1 btn-pub-btn"
                                                                                    onClick={() =>
                                                                                        this.PublishCmsContent(section.ContentID, 1)
                                                                                    }
                                                                                >
                                                                                    Publish
                                                                                </button>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {!section.isFixed && (
                                                                        <>
                                                                            {section.ContentID === 0 ? (
                                                                                <button
                                                                                    className="btn btn-sm px-3 p-1 rounded-1"
                                                                                    onClick={() =>
                                                                                        this.handleRemoveSection(index, section.ContentID)
                                                                                    }
                                                                                >
                                                                                    Remove
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    className={`btn btn-sm px-3 p-1 rounded-1 btn-pub-btn-1 ml-1 ${section.isactive && 'btn-in-act-btn ml-1'
                                                                                        }`}
                                                                                    onClick={() =>
                                                                                        this.toggleSectionStatus(
                                                                                            index,
                                                                                            section.ContentID,
                                                                                            section.isactive
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {section.isactive ? 'In-Activate' : 'Activate'}
                                                                                </button>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* Editable Content */}
                                                            {section.isEdit ? (
                                                                <JoditEditor
                                                                    key={section.ContentID || 0}
                                                                    value={section.SectionContent}
                                                                    config={joditConfig}
                                                                    onChange={(content) =>
                                                                        this.handleEditorChange(content, index)
                                                                    }
                                                                />
                                                            ) : (
                                                                <div
                                                                    dangerouslySetInnerHTML={{ __html: section.SectionContent }}
                                                                />
                                                            )}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            )) : <div>
                                                <p className="text-center">No Contents Available</p>
                                            </div>}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>

                            {cmsSectionData.length > 0 && (
                                <div style={{ textAlign: 'center' }}>
                                    <button className="btn btn-sm contentSubmit rounded-1 mt-4 btn-primary text-white" onClick={() => this.InsertUpdateCmsContent()}>
                                        Submit Contents
                                    </button>
                                </div>
                            )}

                        </div>
                        {/* {cmsSectionData?.length > 0 ? (
                            cmsSectionData
                                .filter(section => section.isPublish && section.isactive)
                                .sort((a, b) => a.SeqNo - b.SeqNo)
                                .map((section, index) => (
                                    <section key={section.ContentID || index} className="p-0">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: purify.sanitize(section.SectionContent),
                                            }}
                                        />
                                    </section>
                                ))
                        ) : null} */}
                        {MenuID == 1 && <>
                            <section
                                className="ticket1 position-relative bg-lightgrey"
                                style={{ padding: "70px 0px" }}
                            >
                                <div className="container">
                                    <div className="ticket-inner  text-center position-relative">
                                        <div className="ticket-title mx-auto">
                                            <h2 className="mb-2">
                                                Our <span className="pink">Jury</span> <br />
                                                <span style={{ fontSize: 20 }}>
                                                    Expert Voices, Fair Judgments
                                                </span>
                                            </h2>
                                            <div className="app">
                                                <div className="speaker-grid">
                                                    {speakers.map((speaker, index) => (
                                                        <div key={index} className="speaker-card">
                                                            <div className="image-container-outline">
                                                                <div className="image-container">
                                                                    {speaker.imgSrc ? (
                                                                        <img
                                                                            src={speaker.imgSrc}
                                                                            alt={speaker.name}
                                                                            onClick={() =>
                                                                                speaker.juryDetailsPdf &&
                                                                                this.setState({
                                                                                    JuryPDF: speaker.juryDetailsPdf,
                                                                                    isOpen: true,
                                                                                    JuryName: speaker.name,
                                                                                })
                                                                            }
                                                                            className="speaker-image"
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            src={"img/profile_img.png"}
                                                                            alt="Profile Preview"
                                                                            className="rounded-circle profile-pic"
                                                                            width="170"
                                                                            height="165"
                                                                            onClick={() =>
                                                                                speaker.juryDetailsPdf &&
                                                                                this.setState({
                                                                                    JuryPDF: speaker.juryDetailsPdf,
                                                                                    isOpen: true,
                                                                                    JuryName: speaker.name,
                                                                                })
                                                                            }
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="social-icons">
                                                                <a href="#" className="icon">
                                                                    <i className="ri-facebook-line"></i>
                                                                </a>
                                                                <a href="#" className="icon">
                                                                    <i className="ri-twitter-line"></i>
                                                                </a>
                                                                <a href="#" className="icon">
                                                                    <i className="ri-instagram-line"></i>
                                                                </a>
                                                                <a href="#" className="icon">
                                                                    <i className="ri-linkedin-line"></i>
                                                                </a>
                                                            </div>
                                                            <h3 className="speaker-name">{speaker.name}</h3>
                                                            <p className="speaker-company">{speaker.company_name}</p>
                                                            <p className="speaker-role">{speaker.role}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ticket-info w-lg-65 mx-auto">
                                            <p>
                                                This is the idea which drives India ITME Society’s search for
                                                talented, stand out leaders, innovators and determined
                                                perseverance in their field of work. To mark 4-decade old
                                                successful journey of India ITME Society an award was initiated
                                            </p>
                                            <div className="ticket-button">
                                                <a className="btn" onClick={() => this.props.navigate('/jury')}>
                                                    Read More <i className="fa fa-angle-double-right" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </>}
                        <>
                            <Modal show={isStaticUploadOpenBanner} size="xl" style={{ left: '2%', top: "10%" }}>
                                <Modal.Header>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>

                                        <Modal.Title>
                                            <h6 style={{ color: 'black', margin: 0 }}>Upload Banner</h6>
                                        </Modal.Title>
                                        {console.log(cmsBannerData, 'cmsBannerData')}
                                        {/* Right Side: Buttons */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            {((cmsBannerData?.BannerFilepath || cmsBannerData?.FilePreview) || (cmsBannerData?.[0]?.BannerFilepath || cmsBannerData?.[0]?.FilePreview)) ? (
                                                <button
                                                    className="btn btn-sm p-1 px-3 btn-outline-moddanger rounded-1 mb-1 mt-1"
                                                    onClick={this.clearFileInput}
                                                >
                                                    Remove
                                                </button>
                                            ) : (
                                                <>
                                                    <label className="btn btn-sm p-1 px-3 btn-outline-modsuccess rounded-1 mb-1 mt-1">
                                                        Upload
                                                        <input
                                                            type="file"
                                                            accept=".jpg,.jpeg,.png"
                                                            onChange={this.handleBannerChange}
                                                            ref={(ref) => (this.fileInputRef = ref)}
                                                            style={{ display: 'none' }}
                                                        />
                                                    </label>
                                                </>
                                            )}


                                            {cmsBannerData?.isActive && (
                                                cmsBannerData?.isPublish ? (
                                                    <button
                                                        className="btn btn-sm p-1 px-2 rounded-1 btn-outline-modsec mb-1 mt-1"
                                                        onClick={() => this.PublishCmsBanner(cmsBannerData?.BannerID, 0)}
                                                    >
                                                        Unpublish
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="btn btn-sm p-1 px-3 rounded-1 btn-pub-btn mb-1 mt-1"
                                                        onClick={() => this.PublishCmsBanner(cmsBannerData?.BannerID, 1)}
                                                    >
                                                        Publish
                                                    </button>
                                                )
                                            )}

                                            <span
                                                onClick={() => this.setState({ isStaticUploadOpenBanner: false })}
                                                style={{ cursor: "pointer", fontWeight: "800", marginLeft: '10px' }}
                                            >
                                                X
                                            </span>
                                        </div>
                                    </div>
                                </Modal.Header>

                                <Modal.Body style={{ height: 'calc(100vh - 375px)' }}>
                                    {((cmsBannerData?.BannerFilepath != "" ? cmsBannerData?.BannerFilepath : cmsBannerData?.FilePreview) || (cmsBannerData?.[0]?.BannerFilepath != "" ? cmsBannerData?.[0]?.BannerFilepath : cmsBannerData?.[0]?.FilePreview)) ? (
                                        <div style={{ position: "relative", display: "inline-block" }}>
                                            <img
                                                src={cmsBannerData?.BannerFilepath ? cmsBannerData?.BannerFilepath : cmsBannerData?.FilePreview}
                                                alt="Preview"
                                                style={{ width: "250px", height: "250px", objectFit: "contain", border: "1px solid #ccc" }}
                                            />
                                        </div>
                                    ) : (<>
                                        {/* <label htmlFor="upload-files" className="btn btn-primary mb-3">
                                    Upload Banner
                                </label> */}
                                        {<span className='text-danger text-start d-block ml-2' style={{ fontSize: 'smaller' }}>{bannerFileErr}</span>}
                                    </>
                                    )}

                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-sm px-3 mb-1 mx-2 p-2 up-btn" onClick={() => this.setState({ isStaticUploadOpenBanner: false })}>Close</button>
                                    <button className="btn btn-sm px-3 mb-1 mx-2  p-2 up-btn" onClick={this.UploadBannerFile}>Submit</button>
                                </Modal.Footer>
                            </Modal>
                            <Modal show={isStaticUploadOpen} size="xl">
                                <Modal.Header>
                                    <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                        {/* <div > */}
                                        <h6> Upload Files - {MenuUrl ? MenuUrl : (MenuID == 1 && 'Home')}</h6>
                                        {/* </div> */}
                                    </Modal.Title>
                                    <span
                                        onClick={() => this.setState({ isStaticUploadOpen: false })}
                                        style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                                    >
                                        X
                                    </span>
                                </Modal.Header>
                                <Modal.Body style={{ height: 'calc(80vh - 76px)' }}>
                                    <label htmlFor="upload-files" className="btn btn-primary mb-3">
                                        Upload Files
                                    </label>
                                    <input
                                        id="upload-files"
                                        type="file"
                                        multiple
                                        accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.xls,.xlsx,.csv,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                        style={{ display: 'none' }}
                                        onChange={this.handleFileChange}
                                    />

                                    {this.state.cmsUploadData?.length > 0 && (
                                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                            < table className="table table-bordered mt-3" >
                                                <thead>
                                                    <tr>
                                                        <th>File Name</th>
                                                        <th>File URL</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.cmsUploadData.map((file, index) => (
                                                        file.isActive === 1 && (
                                                            <tr key={index}>
                                                                <td><a title='View' href={file.FileID && `${downloadUrl + file.FilePath}`} target="_blank">{file.FileName}</a></td>
                                                                <td
                                                                    style={{ cursor: file.FileID ? "pointer" : "default", color: file.FileID ? "#007bff" : "inherit" }}
                                                                    title={file.FileID ? "Click to copy URL" : ""}
                                                                    onClick={() => {
                                                                        if (file.FileID) {
                                                                            const fullUrl = `${downloadUrl + file.FilePath}`;
                                                                            navigator.clipboard.writeText(fullUrl).then(() => {
                                                                                toastSuccess("URL copied to clipboard!");
                                                                            }).catch(err => {
                                                                                toastError("Failed to copy URL: ", err);
                                                                            });
                                                                        }
                                                                    }}
                                                                >
                                                                    {file.FileID ? `${downloadUrl + file.FilePath}` : file.FileName}
                                                                </td>

                                                                <td>
                                                                    <button className="btn btn-sm btn-outline-danger ml-2" title="Remove File" onClick={() => this.removeFile(index, file.FileID)}>
                                                                        <i class="fa fa-trash-o"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-sm px-3 mb-1 mx-2" onClick={() => this.setState({ isStaticUploadOpen: false })}>Close</button>
                                    <button className="btn btn-sm px-3 mb-1 mx-2" onClick={this.UploadStaticFiles}>Submit</button>
                                </Modal.Footer>
                            </Modal>
                            <Modal show={this.state.isOpen} size="lg">
                                <Modal.Header>
                                    <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                        {/* <div > */}
                                        <h6> {JuryName} </h6>
                                        {/* </div> */}
                                    </Modal.Title>
                                    <span
                                        onClick={() => this.setState({ isOpen: false })}
                                        style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                                    >
                                        X
                                    </span>
                                </Modal.Header>
                                <Modal.Body style={{ height: 'calc(100vh - 76px)' }}>
                                    <iframe
                                        id="myIframe"
                                        // src={`/${sessionStorage.getItem("sessionExhibitionID")}/Rules-and-Regulations.pdf#toolbar=0&navpanes=0`}
                                        src={`${JuryPDF}#toolbar=0&navpanes=0`}
                                        // src={`${juryDetailsPdf}`}
                                        width="100%"
                                        height="95%"
                                        title="Bing"
                                    >
                                        &lt;/div&gt; &lt;div style="height: 100px;"&gt;&lt;/div&gt;
                                        &lt;/div&gt; &lt;/div&gt; &lt;/div&gt;
                                    </iframe>
                                </Modal.Body>
                            </Modal>
                        </>
                        <div className="speaker-button text-lg-center m-0 mt-3 text-center">
                            <a className="btn my-2  mx-1 p-1 px-2" onClick={() => this.insertUpdateFooter()}>Submit Footer</a>
                            {cmsFooterData.isPublish ? <>
                                <a className="btn my-2  mx-1 p-1 px-2" onClick={() => this.PublishCmsFooter(0)}>Unpublish Footer</a>
                            </> : <>
                                <a className="btn my-2  mx-1 p-1 px-2" onClick={() => this.PublishCmsFooter(1)}>Publish Footer</a>
                            </>}
                        </div>
                        <JoditEditor value={cmsFooterData.FooterContent} config={joditConfig}
                            onChange={(content) => this.handleEditorChangeFooter(content)} />
                    </div >
                    {/* Update End */}
                </>
                <Modal show={this.state.isOpen2} size="lg" style={{ width: '620px' }}>
                    <Modal.Body
                        style={{
                            backgroundImage: 'url("../static/images/login-page-bg.jpg")',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                        <span
                            className="pop-close"
                            onClick={() => this.setState({ isOpen2: false })}
                        >
                            X
                        </span>
                        <div className="container text-center p-4">
                            <img
                                src="../static/images/pop-logo.png"
                                alt="logo"
                                className="image timer-pop"
                            />
                            <h3 className="py-5 text-center com-soon-tag">Coming Soon</h3>
                            <h5 className="timer-pop-text com-soon">
                                The registration will start on 21<sup>st</sup> February 2025 at 12:00
                                noon (IST)
                            </h5>
                            <h5 className="pt-3 mb-0 pb-0 timer-pop-text com-soon">
                                The registration will be on first come first basis.
                            </h5>
                            <div className="countdown-out mt-2">
                                <div class="countdown">
                                    <div>
                                        <span id="days">30</span>
                                        <small>Days</small>
                                    </div>
                                    <div>
                                        <span id="hours">02</span>
                                        <small>Hours</small>
                                    </div>
                                    <div>
                                        <span id="minutes">41</span>
                                        <small>Minutes</small>
                                    </div>
                                    <div>
                                        <span id="seconds">07</span>
                                        <small>Seconds</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <ToastContainer />
            </>
        );
    }
}
export default withRouter(
    connect(null, {
        getCurrentAwardDetails_action, getActiveJuryDetails_action, getCmsContent_action,
        insertUpdateCmsContent_action, insertUpdateCmsFooter_action, publishCmsContent_action,
        publishCmsFooter_action, insertUpdateCmsContentSection_action, updateCmsContentStatus_action,
        insertUpdateCMSStaticUploads_action, deleteCmsStaticFiles_action, publishCmsBanner_action, insertUpdateCmsBanner_action
    })(CmsHome)
);
